import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import IntegrationTasksApi from '../generated/api/IntegrationTasks';

export default (service: Servicelayer) => ({
  ...IntegrationTasksApi(service),

  // Add custom calls here

});
